<template lang="pug">
div 
  ul.tab
    li.tab-item(v-if="title != ''") 
      a {{title}}
    li.tab-item(v-for="tab in tablist")
      a(@click="tabSelected(tab.id)" v-bind:key="tab.id" v-bind:class="{active: currentName == tab.id}") {{tab.name}}
    li.floatr
      slot(name="extentTab")

  slot(:name="currentName")
  slot(name="common")

</template>
<script>

  export default {
    props: {
      title: String,
      tablist: Array,
      update: Function,
      currentTab: String
    },
    data() {
      return {
        currentName: ""
      }
    },
    watch: {
      tablist(val, oldVal) {
        this.tablist = val
        if(this.currentTab && this.currentName != this.currentTab){
          this.currentName = this.currentTab
        } else {
          this.currentName = this.tablist[0].id
        }
      },
      currentTab(){
        if(this.currentTab != this.currentName){
          this.currentName = this.currentTab
        }
      }
    },
    mounted() {
      if(this.currentTab){
        this.currentName = this.currentTab
      } else {
        this.currentName = this.tablist[0].id
      }
    },
    methods: {
      tabSelected: function(name){
        this.currentName = name
        this.update(name)
      }
    }
  }
</script>
<style scoped>
.tab:hover{
  background: #fff;
}
.tab .tab-item a.active {
  color: #555;
}
.floatr {
  float: right;
}
.tab {
  li {
    line-height: 44px;
    margin-right: 10px;
  }
}
#special-tab .tab .tab-item > a{ width: 80px}
</style>



// WEBPACK FOOTER //
// tab-content.vue?7a60c613